import {
  getBranchBySlug,
} from "../api/maracana";

import {
  getBranchAvailableDays,
  getBranchFields,
} from "../api/bernabeu";

import {
  branchSlice,
  callTypes
} from "../../redux/reducers/branchSlice";

const { actions } = branchSlice;

export const fetchBranches = (slug) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return getBranchBySlug(slug)
    .then((response : any) => {
      const entities = response.data;

      if (entities.length > 0) {
        dispatch(actions.branchesFetched({ entities }));
      } else {
        dispatch(actions.catchError({ error: {}, callType: callTypes.list }));
      }
    }).catch(error => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};


export const fetchBranchAvailableDays = (branch, date, sport = null, couponId = null, fieldId = null) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    dispatch(actions.setBranchAvailableDays({ status: 'requested', data: [] }));

    getBranchAvailableDays(branch, date, sport, couponId, fieldId).then((response : any) => {
      let array = response.data;
      let data : string[] = [];

      for (let i = 0; i < array.length; i += 5) {
        const chunk = array.slice(i, i + 5);

        data.push(chunk);
      }
      // console.log(data);

      dispatch(actions.setBranchAvailableDays({ status: 'completed', data: data }));

      resolve(data);
    }).catch((error) => {
      console.log('fetchBranchAvailableDays falhou:');
      console.log({error});

      dispatch(actions.setBranchAvailableDays({ status: 'completed', data: [] }));

      reject();
    });
  });
}

export const fetchBranchFields = (branchId) => {
  return new Promise((resolve, reject) => {
    getBranchFields(branchId).then((response : any) => {
      if (response.data) {
        resolve(response.data);
      } else {
        reject(false);
      }
    }).catch((error) => {
      console.log('fetchBranchFields falhou:');
      console.log({error});

      reject(false);
    });
  });
}